import * as service from '../../service/CallApi';
import {AccountsRequest} from "../../models/RequestModel";
import {AccountListResponse, initAccountsResponse} from "../../models/ResponseModel";

const types = {
    ACCOUNTS_PENDING_FETCH: "ACCOUNTS_PENDING_FETCH",
    ACCOUNTS_FETCH_SUCCESS: "ACCOUNTS_FETCH_SUCCESS",
    ACCOUNTS_FETCH_FAILURE: "ACCOUNTS_FETCH_FAILURE"
}

export const actions = {
    postAccounts: async (dispatch: any, request: AccountsRequest) => {
        dispatch({type: types.ACCOUNTS_PENDING_FETCH})
        const json: AccountListResponse = await service.postListAccount(request)

        if (json === undefined || json === null) {
            dispatch({type: types.ACCOUNTS_FETCH_FAILURE})
        } else {
            if (json.accounts !== undefined) {
                dispatch({
                    type: types.ACCOUNTS_FETCH_SUCCESS,
                    payload: json
                })
            }

        }
    }
}

const initialState = {
    accounts: initAccountsResponse(),
    isFetching: false
};

export const accountListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.ACCOUNTS_FETCH_SUCCESS:
            return {
                ...state,
                accounts: action.payload,
                isFetching: false
            };
        case types.ACCOUNTS_FETCH_FAILURE:
            return {
                ...state,
                isFetching: false
            };
        case types.ACCOUNTS_PENDING_FETCH:
            return {
                ...state,
                isFetching: true
            }
        default:
            return state;
    }
}